import {createReducer} from '../utils';

import {
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNIN_REQUEST,
  AUTH_ERROR,
  AUTH_SIGNOUT_SUCCESS,
  AUTH_SIGNOUT_REQUEST,
  AUTH_UPDATE_PASSWORD_SUCCESS,
  AUTH_UPDATE_PASSWORD_REQUEST,
  AUTH_USER_MIGRATED
} from '../actions/types';

const initialState = {
  isLoading: false,
  isSignedIn: false,
  token: null,
  errors: [],
  userMigrated: false
};

export default createReducer(initialState, {
  [AUTH_SIGNIN_REQUEST]: state => ({
    ...state,
    isLoading: true,
    errors: [],
    userMigrated: false
  }),
  [AUTH_SIGNIN_SUCCESS]: (state, {token}) => ({
    ...state,
    isLoading: false,
    isSignedIn: true,
    errors: [],
    token
  }),
  [AUTH_SIGNOUT_REQUEST]: state => ({
    ...state,
    isLoading: true,
    errors: []
  }),
  [AUTH_UPDATE_PASSWORD_REQUEST]: state => ({
    ...state,
    isLoading: true,
    errors: []
  }),
  [AUTH_UPDATE_PASSWORD_SUCCESS]: state => ({
    ...state,
    isLoading: false,
    errors: []
  }),
  [AUTH_SIGNOUT_SUCCESS]: () => initialState,
  [AUTH_ERROR]: (state, {errors}) => (
    {
      ...state,
      isLoading: false,
      errors: state.errors.concat([errors])
    }
  ),
  [AUTH_USER_MIGRATED]: state => (
    {
      ...state,
      isLoading: false,
      userMigrated:true,
      errors: []
    }
  )
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js